"use strict";

define(['marionette', './template.html', '../avatar/index'], function (Marionette, template, AvatarView) {
  return Marionette.ItemView.extend({
    template: template,
    ui: {
      avatar: '.avatar'
    },
    options: {
      avatarSize: null
    },
    tagName: 'div',
    onRender: function onRender() {
      new AvatarView({
        showRank: false,
        model: this.model,
        el: this.ui.avatar,
        size: this.getOption('avatarSize')
      }).render();
    },
    className: 'user flag flag--middle'
  });
});